import { createUseStyles } from 'react-jss';

const styles = {
  header: {
    boxShadow: '0px 2px 2px 0px rgba(0, 0, 0, 0.2)'
  },
  headerTitle: {
    fontSize: '200%'
  },
  headerFlexBoxGroup: {
    gap: '2rem'
  },
  headerLabel: {
    fontSize: '110% !important',
    color: 'black'
  },
  headerValue: {
    fontSize: '110% !important',
    padding: '0.3rem 0 0.2rem 0.2rem !important',
    color: '#6a6d70 !important'
  },
  objectPage: {
    height: 'calc(100vh - 3.25rem)',
    overflow: 'hidden',
    '& [data-component-name="ObjectPageTopHeader"] > div': {
      minHeight: 'unset'
    },
    '& [data-component-name="ObjectPageTabContainer"]': {
      visibility: 'hidden',
      marginBottom: 'calc(2.50rem * -1 - 0.25rem)'
    },
    '& [data-component-name="ObjectPageTabContainerPlaceholder"]': {
      display: 'none'
    },
    '& [data-component-name="ObjectPageContent"]': {
      height: '100%',
      overflow: 'hidden'
    }
  },
  objectPageSection: {
    height: '100%',
    '& [data-component-name="ObjectPageSectionTitleText"]': {
      display: 'none'
    },
    '& [data-component-name="ObjectPageSectionContent"]': {
      height: '100%',
      paddingBlockStart: '0'
    }
  },
  objectPageContentWrapper: {
    height: '100%',
    paddingTop: '1rem'
  },
  formContainer: {
    marginTop: '0.7rem'
  },
  formItemText: {
    alignSelf: 'center',
    flexGrow: '1',
    paddingBottom: '0.8rem',
    whiteSpace: 'pre-wrap'
  },
  formItemLabel: {
    paddingBottom: '0.8rem',
    alignSelf: 'start'
  },
  formItemLabelContainer: {
    width: '100%',
    display: 'block',
    textAlign: 'left'
  },
  mainDivLeft: {
    display: 'flex',
    flexDirection: 'column',
    width: '50%',
    paddingRight: '1rem',
    height: `calc(100%)`,
    overflow: 'auto'
  },
  mainDivRight: {
    display: 'flex',
    flexDirection: 'column',
    width: '50%',
    paddingLeft: '1rem',
    height: `calc(100%)`,
    overflow: 'auto'
  },
  actionGroup: {
    justifyContent: 'flex-end'
  },
  actionGroupItem: {
    margin: '0.2rem'
  },
  formLineInput: {
    width: '100%'
  },
  notificationButton: {
    marginLeft: '0.5rem',
    width: 'fit-content'
  },
  infoDataFlexBox: {
    width: '100%',
    maxWith: '100%',
    alignItems: 'start'
  },
  formComponent: {},
  formSwitchLabel: {
    paddingBottom: '0.8rem',
    paddingTop: '0.2rem'
  },
  documentNumberInputContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: '5px'
  }
};

export const useStyles = createUseStyles(styles, {
  name: 'DisplayQuery'
});
